import { useState } from "react";
import { Menu, X, Mail } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleEmailClick = () => {
    navigate("/contact");
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate("/");
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/5abucuep_Hernandez%20Remodeling%20Logo.png" 
              alt="Hernandez Remodeling LLC" 
              className="h-16 md:h-20 w-auto object-contain cursor-pointer"
              onClick={handleLogoClick}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className="text-gray-700 hover:text-crimson-600 font-medium transition-all hover:scale-105 relative group"
            >
              Home
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-crimson-600 transition-all group-hover:w-full"></span>
            </Link>
            <Link
              to="/services"
              className="text-gray-700 hover:text-crimson-600 font-medium transition-all hover:scale-105 relative group"
            >
              Services
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-crimson-600 transition-all group-hover:w-full"></span>
            </Link>
            <Link
              to="/contact"
              className="text-gray-700 hover:text-crimson-600 font-medium transition-all hover:scale-105 relative group"
            >
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-crimson-600 transition-all group-hover:w-full"></span>
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <Button 
              onClick={handleEmailClick}
              className="bg-crimson-600 hover:bg-crimson-700 text-white px-6 py-2 rounded-lg flex items-center space-x-2 transition-all hover:shadow-lg"
            >
              <Mail className="w-4 h-4" />
              <span>Email Us</span>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-crimson-600 font-medium py-2 transition-colors"
              >
                Home
              </Link>
              <Link
                to="/services"
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-crimson-600 font-medium py-2 transition-colors"
              >
                Services
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-crimson-600 font-medium py-2 transition-colors"
              >
                Contact
              </Link>
              <Button 
                onClick={handleEmailClick}
                className="bg-crimson-600 hover:bg-crimson-700 text-white w-full py-2 rounded-lg flex items-center justify-center space-x-2"
              >
                <Mail className="w-4 h-4" />
                <span>Email Us</span>
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
